var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSetPin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PIN",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(4.000000, 4.000000)",
    stroke: "#000000"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 12.6153846,
    cy: 3.38461538,
    r: 2.88461538
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-2",
    cx: 3.38461538,
    cy: 3.38461538,
    r: 2.88461538
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy",
    cx: 21.8461538,
    cy: 3.38461538,
    r: 2.88461538
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 12.6153846,
    cy: 12.6153846,
    r: 2.88461538
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-2",
    cx: 3.38461538,
    cy: 12.6153846,
    r: 2.88461538
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 12.6153846,
    cy: 21.8461538,
    r: 2.88461538
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-2",
    cx: 3.38461538,
    cy: 21.8461538,
    r: 2.88461538
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2394888,9.98794654 C24.5801097,10.3171847 24.8054549,10.7486489 24.8768514,11.2054933 L24.8820574,11.2386286 L24.8887508,11.2710589 L25.6837808,15.1415463 L25.9671357,16.5184246 L27.4218396,16.2568671 C27.6218986,16.2209117 27.828651,16.2025815 28.0324285,16.2025815 C28.2376935,16.2025815 28.4429585,16.2209117 28.6437612,16.2568671 L28.6645852,16.2603921 L28.6854091,16.2639171 C28.9910755,16.3104476 29.2826112,16.4077385 29.5510918,16.5536749 L30.2152282,16.9132284 L30.9098567,16.6114855 C31.2787387,16.4507439 31.6729069,16.3696682 32.0789746,16.3696682 C32.2187928,16.3696682 32.3600984,16.3795383 32.4991728,16.3992784 L32.5252028,16.4035085 L32.5512328,16.4063285 C33.0383652,16.459204 33.5016989,16.663656 33.857194,16.9830241 L34.485632,17.5442095 L35.3111542,17.3066222 C35.5684791,17.2325965 35.8347286,17.1945261 36.1032093,17.1945261 C36.5412566,17.1945261 36.9770728,17.2960471 37.3548794,17.4842839 C37.7840022,17.700721 38.0933871,18.0708496 38.2175872,18.5114788 L38.2175872,18.5220539 L38.2443609,18.6517752 C38.4042594,19.4540729 38.5701075,20.2514356 38.7366994,21.0530284 L38.8185079,21.4478322 L39.2342438,23.4380664 L39.2803541,23.6636686 C39.4484334,24.4850015 39.6098192,25.2731991 39.7593057,26.0564617 L39.7630242,26.0783169 L39.7674865,26.0994671 C40.2256141,28.1411668 40.0047312,30.232922 39.1226868,32.1611156 C38.9546075,32.5404093 38.7478551,32.9070128 38.509123,33.2496461 L38.171477,33.7339858 L38.2912149,34.3029263 L38.5879566,35.7058899 C38.7991713,36.7366098 38.0874373,37.7412445 37.0090525,37.9428765 L29.2379884,39.347955 C29.0937079,39.3712203 28.9457089,39.3839104 28.8110967,39.3846154 C27.8531935,39.3839104 27.0246965,38.7367141 26.8417429,37.8455855 L26.6111917,36.7253297 L26.472861,36.0534582 L25.8317798,35.7411402 C25.4733098,35.5662985 25.1378949,35.3498614 24.8381783,35.103109 C24.4335981,34.7668208 24.062485,34.3910522 23.7359947,33.9870833 L23.7136833,33.959588 L23.6906281,33.9342078 L23.6229502,33.858067 L23.3834744,33.5817044 C22.3459938,32.3867178 21.1932376,31.269282 19.9571855,30.2590073 L19.937849,30.2427921 L19.9185124,30.228692 C19.2067784,29.6844267 18.4139796,29.2501425 17.5624275,28.9357095 C17.2255252,28.7961181 16.9250649,28.5994212 16.6692274,28.3498488 L16.6439411,28.3244686 L16.6171674,28.3012034 C16.2110998,27.9409449 15.9864982,27.43193 16.0006288,26.9391302 C16.0370708,26.3032141 16.3561239,25.7081883 16.8767235,25.3056294 L16.9042409,25.2837742 L16.9310146,25.261214 C17.4293027,24.8360949 18.0726151,24.6020326 18.7427011,24.6020326 C19.0431614,24.6020326 19.3399032,24.6492681 19.6240018,24.742329 L22.0574329,25.5368717 L21.568813,23.1419636 L19.5444244,13.2063026 C19.5317813,13.1491971 19.5183944,13.0935015 19.5050076,13.038511 L19.4990579,13.0131308 L19.4990579,12.9426301 L19.4678219,12.8002187 L19.4261739,12.6126869 C19.4120434,12.5541713 19.3964254,12.4970658 19.37932,12.4399602 L19.37932,12.3828547 L19.3406469,12.2242281 C19.153231,11.4621158 19.3875008,10.6739182 19.9794969,10.1070927 C20.4093634,9.68620363 20.9574804,9.4034959 21.5509639,9.29139982 C21.7495354,9.25685448 21.9525693,9.23570428 22.1474223,9.23076923 L22.2098942,9.23076923 C22.9677384,9.23076923 23.6861658,9.49937682 24.2394888,9.98794654 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 12.6153846,
    cy: 31.0769231,
    r: 2.88461538
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSetPin);
export default __webpack_public_path__ + "static/media/icon-set-pin.5601b226.svg";
export { ForwardRef as ReactComponent };